var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 54,
    viewBox: "0 0 49 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.375 53.75H14.375C0 53.75 0 46.125 0 39.375V36.875C0 31.3 0 25 11.875 25C14.85 25 15.95 25.725 17.5 26.875C17.575 26.95 17.675 27 17.75 27.1L20.3 29.8C22.45 32.075 26.35 32.075 28.5 29.8L31.05 27.1C31.125 27.025 31.2 26.95 31.3 26.875C32.85 25.7 33.95 25 36.925 25C48.8 25 48.8 31.3 48.8 36.875V39.375C48.75 48.925 43.925 53.75 34.375 53.75ZM11.875 28.75C3.75 28.75 3.75 31.3 3.75 36.875V39.375C3.75 46.225 3.75 50 14.375 50H34.375C41.825 50 45 46.825 45 39.375V36.875C45 31.3 45 28.75 36.875 28.75C35.075 28.75 34.7 28.975 33.625 29.775L31.2 32.35C29.4 34.25 26.975 35.3 24.375 35.3C21.775 35.3 19.35 34.25 17.55 32.35L15.125 29.775C14.05 28.975 13.675 28.75 11.875 28.75Z",
    fill: "#026C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.875 28.75C40.85 28.75 40 27.9 40 26.875V11.875C40 6.3 40 3.75 31.875 3.75H16.875C8.75 3.75 8.75 6.3 8.75 11.875V26.875C8.75 27.9 7.9 28.75 6.875 28.75C5.85 28.75 5 27.9 5 26.875V11.875C5 6.3 5 0 16.875 0H31.875C43.75 0 43.75 6.3 43.75 11.875V26.875C43.75 27.9 42.9 28.75 41.875 28.75Z",
    fill: "#026C96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.075 21.825H20.75C19.725 21.825 18.875 20.975 18.875 19.95C18.875 18.925 19.725 18.075 20.75 18.075H29.075C30.1 18.075 30.95 18.925 30.95 19.95C30.95 20.975 30.125 21.825 29.075 21.825Z",
    fill: "#026C96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.175 14.325H18.675C17.65 14.325 16.8 13.475 16.8 12.45C16.8 11.425 17.65 10.575 18.675 10.575H31.175C32.2 10.575 33.05 11.425 33.05 12.45C33.05 13.475 32.225 14.325 31.175 14.325Z",
    fill: "#026C96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMail);
export default __webpack_public_path__ + "static/media/send-mail.3236cea004a3994badf6bcfd243d3129.svg";
export { ForwardRef as ReactComponent };